import Vue from 'vue'
import Vuex from 'vuex'
import incidents from './modules/incidents'
import kycIncidents from './modules/kycIncidents'
import rules from './modules/rules'
import commonStates from './modules/common'
import analysis from './modules/analysis';
import ml from './modules/ml';
import face from './modules/face';
import cdd from './modules/cdd';
import suspectAlbum from './modules/suspectAlbum';
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        incidents, kycIncidents, rules, commonStates, analysis, ml, face, cdd, suspectAlbum
    }
})
